import React, {Component} from 'react';
import style from './Product.module.css';
import Logo from '../../image/icon/index_logo.png';
import Menu from '../../image/icon/icon_menu.png';
import SeeAll from '../../image/icon/see_all.png';
import Jiantou from '../../image/icon/jiantou.png';
import $ from  'jquery';
import creatHistory from 'history/createHashHistory';
import MenuSide from "../../compents/menuSid/MenuSide";
import {Link} from "react-router-dom";
import Zhonghe from "../../image/temp/zhonghe.jpg";
import Taobao from "../../image/temp/taobao.png";
import Alibaba from "../../image/temp/alibaba.png";

class Product extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data:null,
            isMobile:false,
            menuState:false
        };
    }
    componentDidMount() {
        var that=this;

        $.ajax({
            type:'get',
            url:'/product/product.json',
            success:function(data){
                that.setState({
                    data:data[that.props.match.params.id-1]
                })
            }
        })

        window.addEventListener("resize",this.indexChange.bind(this));
        this.indexChange();
    }
    componentWillUnmount(){
        window.removeEventListener('resize',this.indexChange)
    }
    indexChange(){
        this.setState({isMobile: window.innerWidth <= 760});
    }


    handleScrollTop=()=>{
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth',
        });
    }
    seeAll=()=>{
        const history = creatHistory();
        history.goBack();
    }
    goHome=()=>{
        this.props.history.push('/')
    }
    showMenu=()=>{
        this.setState({
            // menuState:!this.state.menuState
        })
    }
    render() {
        return (
            this.state.data!==null? <div className={style.product_info}>
                {this.state.isMobile?<div className={style.header}>
                    <img className={style.logo} src={Logo} title="HOME" onClick={this.goHome}/>
                    <img className={style.menu} src={Menu} title="Menu" onClick={(e)=>this.showMenu(e)}/>
                </div>:<div className={style.header}>
                    <img className={style.logo} src={Logo} title="HOME" onClick={this.goHome}/>
                    <ul>
                        <li>公司行业</li>
                        <li>关于我们</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                    </ul>
                </div>}
                <div className={style.view_container}>
                    <div className={style.product_container}>
                        {
                            this.state.data.product_list.map((item,index)=>{
                                return  <Link to={`Project_info1/${item.product_id}`} key={index}><div className={style.product_wrap}>
                                    <div className={style.wrap_top} style={{backgroundImage:'url('+item.product_img+')'}}></div>
                                    <div className={style.wrap_bottom}>
                                        <h3>{item.title}</h3>
                                        <p>{item.info}</p>
                                        <div className={style.more}>更多详情 →</div>
                                    </div>
                                </div>
                                </Link>
                            })
                        }
                    </div>
                </div>

                <div className={style.see_all} onClick={this.seeAll}>
                    <img src={SeeAll}/>
                    <p>查看所有行业</p>
                </div>
                <div className={style.footer} onClick={this.handleScrollTop}>
                    <div className={style.top_btn}>
                        <img src={Jiantou}/>
                        <p>顶部</p>
                    </div>
                    <ul>
                        <li>关于我们</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                    </ul>

                    <div className={style.qrcode_wrap}>
                        <img src={Zhonghe}></img>
                        <img src={Taobao}></img>
                        <img src={Alibaba}></img>
                    </div>

                    <a className={style.bottom} href={`https://beian.miit.gov.cn`}>
                            <p>Copyright © 2019 eyemove.All right reserved</p>
                            <p> 沪ICP备15012399号-1</p>
                    </a>
                </div>
                <MenuSide menuState={this.state.menuState} close={(e)=>this.showMenu(e)}></MenuSide>
            </div>:""
        );
    }
}

export default Product;